import React from "react";

const LayoutTopLineIcon = () => (
	<g>
		<path d='M21 3C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21ZM4 10V19H20V10H4ZM4 8H20V5H4V8Z' />
	</g>
);

export default LayoutTopLineIcon;
